<div class="contenedor-filtros p-16">
    <h2 class="m-0">Filtros</h2>
    <mat-divider></mat-divider>
    <br />
    <div
        fxLayoutGap="30px"
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign="space-between center"
    >
        <mat-form-field class="full-width">
            <mat-label>Nombre</mat-label>

            <mat-chip-list #nombreList aria-label="Nombre" [multiple]="false">
                <mat-chip
                    class="primary"
                    *ngFor="let nombreSeleccionado of filtros.nombre"
                    [removable]="true"
                    (removed)="quitarFiltro('nombre')"
                >
                    <span>{{ nombreSeleccionado.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.nombre[0].descripcion === '*'"
                    #nombreInput
                    [formControl]="nombreCtrl"
                    [matChipInputFor]="nombreList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="
                        agregarFiltro($event, nombreCtrl, 'nombre')
                    "
                />
            </mat-chip-list>
        </mat-form-field>
        <mat-form-field class="full-width">
            <mat-label>Rut</mat-label>

            <mat-chip-list #rutList aria-label="Rut" [multiple]="false">
                <mat-chip
                    class="primary"
                    *ngFor="let rutSeleccionado of filtros.rut"
                    [removable]="true"
                    (removed)="quitarFiltro('rut')"
                >
                    <span>{{ rutSeleccionado.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.rut[0].descripcion === '*'"
                    #nombreInput
                    [formControl]="rutCtrl"
                    [matChipInputFor]="rutList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="
                        agregarFiltro($event, rutCtrl, 'rut')
                    "
                />
            </mat-chip-list>
        </mat-form-field>
        <mat-form-field class="full-width">
            <mat-label>Comunas</mat-label>
            <mat-chip-list #comunasList aria-label="Comunas" [multiple]="false">
                <mat-chip
                    class="primary"
                    *ngFor="let comunaSeleccionada of filtros.comuna"
                    [removable]="true"
                    (removed)="quitarFiltro('comuna')"
                >
                    <span>{{ comunaSeleccionada.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.comuna[0].descripcion === '*'"
                    #comunaInput
                    [formControl]="comunaCtrl"
                    [matAutocomplete]="autoCompleteComuna"
                    [matChipInputFor]="comunasList"
                />
            </mat-chip-list>
            <mat-autocomplete
                #autoCompleteComuna="matAutocomplete"
                (optionSelected)="
                    seleccionarFiltro(
                        $event,
                        'id',
                        'nombre',
                        comunaCtrl,
                        'comunaInput',
                        'comuna'
                    )
                "
            >
                <mat-option
                    *ngFor="let comunaFiltrada of filteredComunas | async"
                    [value]="comunaFiltrada"
                >
                    {{ comunaFiltrada.nombre }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-label>Grupos de servicio</mat-label>

            <mat-chip-list
                #grupoServicioList
                aria-label="Grupo Servicios"
                [multiple]="false"
            >
                <mat-chip
                    class="primary"
                    *ngFor="let grupoSeleccionado of filtros.grupo"
                    [removable]="true"
                    (removed)="quitarFiltro('grupo')"
                >
                    <span>{{ grupoSeleccionado.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.grupo[0].descripcion === '*'"
                    #grupoServicioInput
                    [formControl]="grupoServicioCtrl"
                    [matAutocomplete]="autoCompleteGrupo"
                    [matChipInputFor]="grupoServicioList"
                />
            </mat-chip-list>
            <mat-autocomplete
                #autoCompleteGrupo="matAutocomplete"
                (optionSelected)="
                    seleccionarFiltro(
                        $event,
                        'id',
                        'descripcion',
                        grupoServicioCtrl,
                        'grupoServicioInput',
                        'grupo'
                    )
                "
            >
                <mat-option
                    *ngFor="let grupoFiltrado of filteredGrupos | async"
                    [value]="grupoFiltrado"
                >
                    {{ grupoFiltrado.descripcion }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-label>Evaluación</mat-label>

            <mat-chip-list
                #evaluacionList
                aria-label="Evaluación"
                [multiple]="false"
            >
                <mat-chip
                    class="primary"
                    *ngFor="let evaluacionSeleccionada of filtros.evaluacion"
                    [removable]="true"
                    (removed)="quitarFiltro('evaluacion')"
                >
                    <span>{{ evaluacionSeleccionada.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.evaluacion[0].descripcion === '*'"
                    #evaluacionInput
                    [formControl]="evaluacionCtrl"
                    [matAutocomplete]="autoCompleteEvaluacion"
                    [matChipInputFor]="evaluacionList"
                />
            </mat-chip-list>
            <mat-autocomplete
                #autoCompleteEvaluacion="matAutocomplete"
                (optionSelected)="
                    seleccionarFiltro(
                        $event,
                        'valor',
                        'descripcion',
                        evaluacionCtrl,
                        'evaluacionInput',
                        'evaluacion'
                    )
                "
            >
                <mat-option
                    *ngFor="
                        let evaluacionFiltrado of filteredEvaluaciones | async
                    "
                    [value]="evaluacionFiltrado"
                >
                    {{ evaluacionFiltrado.descripcion }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-label>Estado</mat-label>

            <mat-chip-list #estadosList aria-label="Estado" [multiple]="false">
                <mat-chip
                    class="primary"
                    *ngFor="let estadoSeleccionado of filtros.estado"
                    [removable]="true"
                    (removed)="quitarFiltro('estado')"
                >
                    <span>{{ estadoSeleccionado.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.estado[0].descripcion === '*'"
                    #estadoInput
                    [formControl]="estadoCtrl"
                    [matAutocomplete]="autoCompleteEstado"
                    [matChipInputFor]="estadosList"
                />
            </mat-chip-list>
            <mat-autocomplete
                #autoCompleteEstado="matAutocomplete"
                (optionSelected)="
                    seleccionarFiltro(
                        $event,
                        'valor',
                        'descripcion',
                        estadoCtrl,
                        'estadoInput',
                        'estado'
                    )
                "
            >
                <mat-option
                    *ngFor="let estadoFiltrado of filteredEstados | async"
                    [value]="estadoFiltrado"
                >
                    {{ estadoFiltrado.descripcion }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
    <div fxLayoutGap="10px" fxLayout="row" fxLayoutAlign="start start">
        <button
            mat-raised-button
            color="primary"
            (click)="limpiarTodosFiltros()"
        >
            <mat-icon>clear</mat-icon>
            Limpiar filtros
        </button>
        <button mat-raised-button color="accent" (click)="filtrar()">
            <mat-icon>tune</mat-icon> Filtrar
        </button>
    </div>
</div>
